/* Makeup Geek - (1) "someone bought" popup, REAL orders only (data: #mg-sales-data, filled from shop metafield mgeek.recent_sales);
 * (2) a close (X) on the cookie banner for phones (the X = "Decline", the privacy-friendly choice; styling is in mg-sales.css).
 * The popup shows only purchases from the last MAX_AGE_DAYS days, one at a time, each at most once per visit, never while the
 * cookie banner is open; it shows the country only, never a name. If there is no recent real purchase, nothing is shown. */
(function () {
  'use strict';
  var MAX_AGE_DAYS = 7;
  var FIRST_DELAY = 8000;   // ms before the first notification
  var SHOW_FOR = 7000;      // ms each notification stays
  var GAP = 22000;          // ms between notifications
  var SEEN_KEY = 'mg_sales_seen';
  var OFF_KEY = 'mg_sales_off';

  function store(get, key, val) {
    try { if (get) return sessionStorage.getItem(key); sessionStorage.setItem(key, val); } catch (e) {}
    return null;
  }
  function ago(ms) {
    var m = Math.floor(ms / 60000);
    if (m < 2) return 'just now';
    if (m < 60) return m + ' minutes ago';
    var h = Math.floor(m / 60);
    if (h < 24) return h === 1 ? '1 hour ago' : h + ' hours ago';
    var d = Math.floor(h / 24);
    return d === 1 ? '1 day ago' : d + ' days ago';
  }
  function bannerOpen() {
    var b = document.getElementById('shopify-pc__banner');
    return !!b && b.offsetHeight > 0 && getComputedStyle(b).display !== 'none';
  }

  function init() {
    var dataEl = document.getElementById('mg-sales-data');
    if (!dataEl || store(true, OFF_KEY) === '1') return;
    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var now = Date.now();
    items = (items || []).map(function (i) { i.ts = Date.parse(i.t); return i; })
      .filter(function (i) { return i.ts && now - i.ts >= 0 && now - i.ts <= MAX_AGE_DAYS * 86400000; })
      .sort(function (a, b) { return b.ts - a.ts; });
    var seen = [];
    try { seen = JSON.parse(store(true, SEEN_KEY) || '[]'); } catch (e) {}
    items = items.filter(function (i) { return seen.indexOf(i.url + i.t) < 0; });
    if (!items.length) return;

    var card = document.createElement('a');
    card.className = 'mg-sales';
    card.hidden = true;
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');
    var img = document.createElement('img'); img.className = 'mg-sales__img'; img.alt = ''; img.width = 56; img.height = 56;
    var body = document.createElement('span'); body.className = 'mg-sales__body';
    var who = document.createElement('span'); who.className = 'mg-sales__who';
    var name = document.createElement('span'); name.className = 'mg-sales__name';
    var meta = document.createElement('span'); meta.className = 'mg-sales__meta';
    body.appendChild(who); body.appendChild(name); body.appendChild(meta);
    var x = document.createElement('button'); x.type = 'button'; x.className = 'mg-sales__x'; x.setAttribute('aria-label', 'Close'); x.textContent = '×';
    card.appendChild(img); card.appendChild(body); card.appendChild(x);
    document.body.appendChild(card);

    var stopped = false, timer;
    x.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      stopped = true; clearTimeout(timer); store(false, OFF_KEY, '1');
      card.classList.remove('is-on');
      setTimeout(function () { card.hidden = true; }, 400);
    });

    var idx = 0;
    function showNext() {
      if (stopped || idx >= items.length) return;
      if (bannerOpen()) { timer = setTimeout(showNext, 3000); return; }   // never on top of the cookie banner
      var i = items[idx++];
      card.href = i.url;
      img.src = i.img;
      who.textContent = 'Someone in ' + i.country + ' bought';
      name.textContent = i.title;
      meta.textContent = '';
      meta.appendChild(document.createTextNode(ago(Date.now() - i.ts) + ' · '));
      var b = document.createElement('b'); b.textContent = 'Verified purchase'; meta.appendChild(b);
      seen.push(i.url + i.t); store(false, SEEN_KEY, JSON.stringify(seen));
      card.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.add('is-on'); }); });
      timer = setTimeout(function () {
        card.classList.remove('is-on');
        timer = setTimeout(function () { card.hidden = true; timer = setTimeout(showNext, GAP); }, 400);
      }, SHOW_FOR);
    }
    timer = setTimeout(showNext, FIRST_DELAY);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Cookie banner: add a close (X) button. It does exactly what "Decline" does. Only visible on phones (CSS). */
(function () {
  'use strict';
  function addX() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    if (b.querySelector('.mg-cc-x')) return true;
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'mg-cc-x';
    x.setAttribute('aria-label', 'Close and decline optional cookies');
    x.textContent = '×';
    x.addEventListener('click', function () {
      var d = document.getElementById('shopify-pc__banner__btn-decline');
      if (d) d.click();
    });
    b.appendChild(x);
    return true;
  }
  if (addX()) return;
  if (!window.MutationObserver) return;
  var mo = new MutationObserver(function () { if (addX()) mo.disconnect(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 20000);
})();